import React from "react";
import { useLocation } from "react-router-dom";
import SEO from "./SEO";

/**
 * Métadonnées des pages qui n'affichent pas leur propre <SEO> (statiques + transactionnelles).
 * Les autres pages (accueil, listes, détails, pages légales) gèrent leurs balises elles-mêmes :
 * aucune règle ici pour elles, afin de ne pas écraser leurs valeurs.
 * Les pages de réservation, de compte et de confirmation sont en noindex.
 */
const STATIC_PAGES = {
    "/about": {
        title: "About SouthTrip · Kerala-only Cab & Tour Specialists",
        description:
            "SouthTrip is a Kerala-only cab and tour team based in Angamaly. Verified drivers, transparent fares and 24/7 support for airport transfers and tour packages.",
    },
    "/contact": {
        title: "Contact SouthTrip · Kerala Cab Booking & 24/7 Support",
        description:
            "Call +91 80758 14740, WhatsApp or email info@southtrip.in. Our Angamaly-based team answers Kerala cab, airport transfer and tour package enquiries 24/7.",
    },
};

const NOINDEX_PAGES = [
    { test: (p) => p === "/login", title: "Sign in · SouthTrip.in" },
    { test: (p) => p === "/register", title: "Create an account · SouthTrip.in" },
    { test: (p) => p === "/my-bookings", title: "My bookings · SouthTrip.in" },
    { test: (p) => p.startsWith("/booking/confirmation/"), title: "Booking confirmation · SouthTrip.in" },
    { test: (p) => p.startsWith("/cab-booking/book/"), title: "Book your cab · SouthTrip.in" },
    { test: (p) => p.startsWith("/airport-transfers/book/"), title: "Book your airport transfer · SouthTrip.in" },
    { test: (p) => p.startsWith("/tour-packages/book/"), title: "Book your tour package · SouthTrip.in" },
];

const RouteSEO = () => {
    const { pathname } = useLocation();
    const path = pathname.replace(/\/+$/, "") || "/";

    if (STATIC_PAGES[path]) return <SEO {...STATIC_PAGES[path]} path={path} />;

    const rule = NOINDEX_PAGES.find((r) => r.test(path));
    if (rule) {
        return <SEO title={rule.title} description="Secure SouthTrip.in booking page." path={path} noindex />;
    }
    return null;
};

export default RouteSEO;
